import { Component, inject, Input, ViewChild } from '@angular/core';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { QuestionnaireComponent } from 'components/questionnaire/questionnaire.component';
import { OrderLineModel } from 'models/generated/Entities.GormCrm.OrderLine';
import { ButtonComponent } from 'components/input/button/button.component';
import { NavigationService } from 'services/navigation.service';

@Component({
	selector: 'edit-questionnaire-replies',
	templateUrl: './edit-questionnaire-replies.component.html',
	imports: [Layout, TranslatePipe, QuestionnaireComponent, ButtonComponent]
})
export class EditQuestionnaireRepliesComponent {
	@Input() header: string = '';
	@Input() questionnaireId?: string;
	@Input() orderLines?: OrderLineModel[];
	@Input() displayAsForm = false;

	@ViewChild(QuestionnaireComponent) questionnaire?: QuestionnaireComponent;
	private readonly navigation = inject(NavigationService);

	async saveReplies() {
		await this.questionnaire?.saveAllReplies();
		this.navigation.closeView(this);
	}
}
